import * as React from 'react';
import BooksSidebar, { Sections } from '../BooksSidebar/BooksSidebar';
import Dialog from '@material-ui/core/Dialog';
import { LibraryCard } from '../../../types/LibraryCard';
import { CalendarState } from '../../../store/calendar/reducers';
import '../BookCalendar.css';
import './MobileCalendar.css';
import '../../Footer/MobileFooter/MobileFooter.css';
import MobileBookCard from './MobileBookCard/MobileBookCard';
import { useHistory } from 'react-router-dom';

interface Props {
	readNow: LibraryCard[];
	alreadyRead: LibraryCard[];
	wantRead: LibraryCard[];
	books: CalendarState;
	cardId?: number;
	setCard: (cardId: number) => void;
	defaultSection?: string;
	loading?: boolean;
}

const MobileCalendar: React.FC<Props> = props => {
	const [selectedSection, setSection] = React.useState(props.defaultSection ? props.defaultSection as any : Sections.All);

	const history = useHistory();

	const onClose = () => {
		// #FIXME
		//window.location.href = '/books'
		props.setCard(-1);
	}

	return (
		<div>
			<BooksSidebar
				readNow={props.readNow}
				alreadyRead={props.alreadyRead}
				wantRead={props.wantRead}
				onCardSelect={(bookId) => props.setCard(bookId)}
				onlySection={selectedSection}
				onChangeSection={setSection}
			/>

			<Dialog
				fullScreen={true}
				open={props.cardId > 0 && !!props.books[props.cardId]}
				onClose={onClose}
				classes={{
					root: "mobile-book-card",
				}}
			>
				{props.cardId > 0 && props.books[props.cardId] && (
					<MobileBookCard
						onClose={onClose}
						card={props.books[props.cardId]}
					/>
				)}
			</Dialog>
		</div>
	);
};

export default MobileCalendar;